import { render, staticRenderFns } from "./InsaView.vue?vue&type=template&id=de696c5a&scoped=true&"
import script from "./InsaView.vue?vue&type=script&lang=js&"
export * from "./InsaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de696c5a",
  null
  
)

export default component.exports